import React, { useState, useEffect } from "react";
// Use Forms
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
// React Bootstrap
import { Container, Form, Button, Col, Alert } from "react-bootstrap";
// Custom spinner
import { addYears, dateToString2 } from "../../../utils";
import { lugarMision, nivelMision } from "../../../contexto";
// jquery
import $ from "jquery";
import SearchSelectObserver from "../../generic/MySearchSelectObserver";
import HorizontalCard from "../../generic/HorizontalCard";
import styled from "styled-components";

const CardUsuario = styled(HorizontalCard)`
  width: 100%;
`;

const MisionExtraForm = ({ misionExtra, submissionHandler, userId = null, ...props }) => {
  let userIdBandera = userId ? userId : null
  userIdBandera = userIdBandera ? userIdBandera : misionExtra?.userId ? misionExtra?.userId : null
  

  const necesitoGenericSearch = userIdBandera ? false : true
    // Métodos para use hook forms 112022 no se como pero funciona. Default values a methods y methos a defaulvalue para el uso del genericSearch de hermanas 
  const methods = useForm({
    defaultValues: {
      cargo: misionExtra?.cargo ? misionExtra.cargo : '',
      descripcion: misionExtra?.descripcion ? misionExtra.descripcion : '',
      lugar: misionExtra?.lugar ? misionExtra.lugar : '',
      nivel: misionExtra?.nivel ? misionExtra.nivel : '',
      startDate: misionExtra?.startDate ? misionExtra.startDate : dateToString2(new Date()),
      endDate: misionExtra?.endDate ? misionExtra.endDate : '',
      userId: misionExtra?.userId ? misionExtra.userId : userId,
      missionId: misionExtra?.missionId ? misionExtra.missionId: '',
      id: misionExtra?.id ? misionExtra.id : null
    },
  });

  // Validación del formulario
  const [validated] = useState(false);
  // Exportamos las funciones de la librería del hook forms
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    //getValues,
    watch,
  } = methods

  // FORMS Functions
  const onSubmit = (data) => {
    // De esta manera nos aseguramos que la fecha endDate estará a null
    if (data.id === null) {
      //estoy insertando
      delete data.id
    }
    if (data.endDate === null) {
      delete data.endDate
      //data.endDate = null;
    }
    if (data.missionId === '') {
      delete data.missionId
      //data.endDate = null;
    }
    submissionHandler(data);
  };

  // Procesamiento de la función que obtiene los usuarios
  const processUsuarios = (usuarios) => {
    return usuarios.map((miUsuario) => {
      let nuevoUsuario = {};
      nuevoUsuario.component = (
        <CardUsuario
          title={<small>{`${miUsuario.name} ${miUsuario.firstSurname} ${miUsuario.secondSurname}`}</small>}
          heightPhoto={"4rem"}
          cardImage={miUsuario.photo ? `${process.env.REACT_APP_API_URL}/download/usuarios/${miUsuario.id}` : "/images/nun.png"}
          imgOnError={"/images/nun.png"}
          destino={miUsuario.sister?.destinations[0] ?
            `Último destino ${miUsuario.sister?.destinations[0]?.endDate ?
              `${new Date(miUsuario.sister?.destinations[0]?.endDate) < new Date() ? `finalizado` : `finaliza`} el ${miUsuario.sister?.destinations[0]?.endDate}`
              :
              `aún en vigor`
            }: ${miUsuario.sister?.destinations[0]?.province?.name}, ${miUsuario.sister?.destinations[0]?.community?.name}`
            :
            null}
        />
      );

      nuevoUsuario.name = `${miUsuario.name} ${miUsuario.firstSurname} ${miUsuario.secondSurname}`;
      nuevoUsuario.value = miUsuario.id;
      return nuevoUsuario;
    });
  };

  // Obtiene la url para pedir usuarios
  const getUrl = (page, findName, consulta, usuarioId) => {
    return `${process.env.REACT_APP_API_URL}/usuarios?type=Monja&page=${page}&provincia=&findName=${findName}`;
  };

  const [misiones, setMisiones] = useState()
  // Default value para el search select
  const [defaultUsuario, setDefaultUsuario] = useState({});
  // Usuarios para el search select
  const [usuarios, setUsuarios] = useState([]);
  // Para el search select
  const getUsuarios = (page, findName, consulta, usuarioId) => {
    let settings = {
      // TODO
      url: getUrl(page, findName, consulta, usuarioId),
      method: "GET",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

  // Manejador de la respuesta de getUsuarios
  const  handleGetUsuarios = (page = 1, findName = "", addMore = false) => {
    return getUsuarios(page, findName)
      .then((response) => {
        addMore ? setUsuarios([...usuarios, ...processUsuarios(response.items)]) : setUsuarios(processUsuarios(response.items));
        return response;
      })
      .catch(() => {
      });
  };

  const getMisiones = async (tipo) => {
    //tipo proyecto u obre
    let settings = {
      // TODO
      url: `${process.env.REACT_APP_API_URL}/misiones?type=${tipo}`,
      method: "GET",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  }

  const handleGetMisiones = async (tipo) => {
    const tiposo = tipo === 'Obra STJ' ? 'obra' : tipo === 'Proyecto STJ' ? 'proyecto' : ''
    const misions = await getMisiones(tiposo)
    setMisiones(await misions)
  }
  useEffect(() => {
    //setUsuarioSeleccionado(watch().userId)
    setMisiones(handleGetMisiones(watch().lugar))

  }, [watch().lugar]);

  return (
    <Container className="my-1 position-relative">
      <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)} className="rounded p-4">
        <fieldset disabled={false}>
          <Form.Row>
            <small className="mb-3">
              Los campos con un <b>*</b> deben de ser rellenados.
            </small>
          </Form.Row>

          {necesitoGenericSearch && <Form.Row>
            <Form.Group as={Col} xs={12} md controlId="userId">
              <Form.Label>{"Hermana"}</Form.Label>
              <SearchSelectObserver
                options={usuarios}
                name={"userId"}
                reactHookFormsRef={
                  register("userId", { required: "Este campo es obligatorio", })
                }
                requestMoreOptions={handleGetUsuarios}
                methods={methods}
                defaultValue={defaultUsuario}
                ErrorMessage={ErrorMessage}
              />
              <ErrorMessage errors={errors} name="userId" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
            </Form.Group>
          </Form.Row>
          }

          {necesitoGenericSearch && <Form.Row>
            <Form.Group as={Col} xs={12} md controlId="lugar">
              <Form.Label>{"Lugar "}</Form.Label>
              <Form.Control
                as="select"
                custom
                name="lugar"
                isInvalid={errors.lugar}
                {...register("lugar", {
                  //required: "Este campo es obligatorio",
                })}
              >
                {lugarMision.map((lugar) => (
                  <option key={lugar} value={lugar}>
                    {lugar}
                  </option>
                ))}
              </Form.Control>
              <ErrorMessage errors={errors} name="lugar" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
            </Form.Group>

            <Form.Group as={Col} xs={12} md controlId="nivel">
              <Form.Label>{"Nivel "}</Form.Label>
              <Form.Control
                as="select"
                custom
                name="nivel"
                isInvalid={errors.nivel}
                {...register("nivel", {
                  //required: "Este campo es obligatorio",
                })}
              >
                
                {nivelMision.map((nivel) => (
                  <option key={nivel} value={nivel} >
                    {nivel}
                  </option>
                ))}
              </Form.Control>
              <ErrorMessage errors={errors} name="nivel" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
            </Form.Group>
          </Form.Row>
          }

          {necesitoGenericSearch &&
            <Form.Group as={Col} xs={12} md controlId="missionId">
            <Form.Label>{"Misión "}</Form.Label>
            <Form.Control
                as="select"
                custom
                name="missionId"
                isInvalid={errors.missionId}
                {...register("missionId", {
                  //required: "Este campo es obligatorio",
                })}
              >
                <option key="" value="" ></option>
                {misiones?.items?.length && misiones.items.map((mision) => (
                  <option key={mision.id} value={mision.id} >
                    {mision.name}
                  </option>
                ))}
              </Form.Control>
            <ErrorMessage errors={errors} name="missionId" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
          </Form.Group>
          } 

          <Form.Row>
            <Form.Group as={Col} xs={12} md controlId="startDate">
              <Form.Label>Fecha de inicio *</Form.Label>
              <Form.Control
                name="startDate"
                type="date"
                isInvalid={errors.startDate}
                {...register("startDate", {
                  required: "Este campo es obligatorio",
                })}
              />
              <ErrorMessage errors={errors} name="startDate" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} xs={12} md controlId="endDate">
              <Form.Label>Fecha de término</Form.Label>
              <Form.Control name="endDate" type="date" isInvalid={errors?.endDate} {...register("endDate", {
                validate: {
                  correctDate: (date) => {
                    if (date) return new Date(date) < new Date(watch("startDate")) ? "La fecha no debe ser menor a la fecha de inicio" : true;
                  },
                },
              })} />
              <ErrorMessage errors={errors} name="endDate" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} xs={12} md controlId="cargo">
              <Form.Label>{"Misión "}*</Form.Label>
              <Form.Control
                name="cargo"
                type="text"
                as={"textarea"}
                isInvalid={errors?.cargo}
                {...register("cargo", {
                  required: "Este campo es obligatorio",
                  maxLength: {
                    value: 150,
                    message: "El máximo de caracteres es 150",
                  },
                })}
              />
              <ErrorMessage errors={errors} name="cargo" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} xs={12} md controlId="descripcion">
              <Form.Label>{"Descripción "}*</Form.Label>
              <Form.Control
                name="descripcion"
                type="text"
                as={"textarea"}
                isInvalid={errors?.descripcion}
                {...register("descripcion", {
                  required: "Este campo es obligatorio",
                  maxLength: {
                    value: 1000,
                    message: "El máximo de caracteres es 1000",
                  },
                })}
              />
              <ErrorMessage errors={errors} name="descripcion" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
            </Form.Group>
          </Form.Row>

          <Button variant="outline-primary" type="submit" className="my-3 w-100">
            {"Añadir"}
          </Button>
        </fieldset>
      </Form>
    </Container>
  );
};

export default MisionExtraForm;
